import { configureStore } from '@reduxjs/toolkit';
import fileReducer from './fileSlice';  // 리듀서가 올바르게 임포트되었는지 확인

export const store = configureStore({
  reducer: {
    files: fileReducer,  // 리듀서가 'files' 키로 설정되었는지 확인
  },
});

export default store;
